// import config from '@/config/index' // 路径配置
import {
    loading
} from '@/common/loading';
import {
    getCityCollectionTask,
    checkLogin,
    getIssueRangeList,
    getTaskNameList,
    getCaseCountNew
} from '@/api/baseMsg';
import processPage from "@/components/processPage";
export default {
    name: "agentFill",
    components: {
        processPage
    },
    data() {
        return {
            type: this.$route.query.type,
            // =========start======by wangry
            title: '市级代填报',
            tableList: [],
            active: !Number(this.$route.query.active) ? 0:Number(this.$route.query.active) ,
            startTime: '',
            endTime: '',
            active2: this.$route.query.active2==1 ? 1:0,
            loading1: false, //tabcard加载
            finished: false,
            // todayCardList: [],//当日卡片列表
            todayCardList: [],//当日卡片列表
            allCardList: [],//全部卡片列表
            isBarNav: false,
            btnFlag: false,
            isBlue: 'blue2',//蓝色
            isGreen: 'green',//绿色
            isGrey: 'grey',//灰色
            isLoading:false,
            //===========end==========
            loginStatus: true,
            option1: [],
			option2: [],
            dtcount:0,//待采集
            // 2022-01-17新增
            dropdownTitle: "",//下拉展示标题
            dropdownInput: "",//搜索筛选框
            inputTable: [],//新数组作为筛选存储数组
            showDrop: false,//展示drop标记
            taskCode:'',//任务code
        }
    },
    created() {
        this.init();
    },
    mounted() {
        window.addEventListener('scroll', this.scrollToTop);
    },
    destroyed() {
        window.removeEventListener('scroll', this.scrollToTop)
    },
    methods: {
        init() {
            loading(true);
            this.checkLogin();
            if (this.loginStatus) {
                this.getTaskNameList();
            }
        },
        getTaskNameList() {
            getTaskNameList({taskCode: "",taskName: "",ordercol: ""}).then(res => {
                this.tableList=res;
                this.inputTable = res;
                this.getCaseCount();
                this.getIssueRangeList();
               
            })
        },
         //价格采集和价格审核数量
         getCaseCount(){
            getCaseCountNew({
                taskCode:this.taskCode,
            }).then(res=>{
                this.dtcount=res[3].unCityDonCount;//市级待审核
                this.getCollectionTask();
            })
        },
        // 获取期号范围函数===wangry 2022-01-11
		getIssueRangeList() {
			getIssueRangeList({}).then(res =>{
                res.forEach(i=> {
                    if(i.codeName == '全部') {
                        i.codeValue = ''
                    }
                    i.value = i.codeValue
                    i.text = i.codeName
                })
                this.option1 = res;
                this.option2 = res;
                this.endTime = this.$route.query.endTime ? this.$route.query.endTime : res[1].value
                this.startTime = this.$route.query.startTime ? this.$route.query.startTime : res[1].value
                this. getAllCollectionTask();
			})
		},
        //当日任务
        getCollectionTask(){
            getCityCollectionTask({
                active:0,
                taskCode:this.taskCode,
                startTime: '',//开始时间
                endTime: ''//结束时间
            }).then(res=>{
                this.todayCardList=res
                this.dtcount = Number(res.length) - Number(this.dtcount)
                loading(false);
            })
        },
        //全部任务
        getAllCollectionTask(){
            loading(true)
            getCityCollectionTask({
                active:1,
                taskCode:this.taskCode,
                startTime: this.startTime,//开始时间
                endTime: this.endTime//结束时间
            }).then(res=>{
                this.allCardList=res;
                loading(false);
            })
        },

       
        toList(item) {//跳转  填报详情页面
            if(item.ifJCDApp == 1) {
                // this.$router.push({
                //     path: '/tianbaoxiangqingLess',
                //     query: {
                //         taskCode:item.taskCode,
                //         exeno: item.exeno,
                //         taskId:item.taskID,
                //         stateId:item.stateId,
                //         shengspflag:item.shengspflag,
                //         active2:this.active2,
                //         levelNum:item.levelNum,
                //         priceDate:item.priceDate,
                //         shispflag:item.shispflag,//市审核
                //         dsbflag:item.dsbflag,//待上报
                //         ythflag:item.ythflag,//已退回
                //         dlrflag:item.dlrflag,//待录入
                //     }
                // });
                this.$router.push({
                    path: '/tianbaoxiangqing',
                    query: {
                        taskCode: item.taskCode,
                        exeno: item.exeno,
                        taskId:item.taskID,
                        stateId:item.stateId,
                        shengspflag:item.shengspflag,//省审核
                        shispflag:item.shispflag,//市审核
                        dlrflag:item.dlrflag,//待录入
                        dsbflag:item.dsbflag,//待上报
                        ythflag:item.ythflag,//已退回
                        active2:this.active2,
                        levelNum:item.levelNum,
                        priceDate:item.priceDate,
                        lateReportTime:item.lateReportTime,
                        startTime: this.startTime,
                        endTime: this.endTime
                    }
                });
            }else {
                this.$router.push({
                    path: '/tianbaoxiangqing',
                    query: {
                        taskCode: item.taskCode,
                        exeno: item.exeno,
                        taskId:item.taskID,
                        stateId:item.stateId,
                        shengspflag:item.shengspflag,//省审核
                        shispflag:item.shispflag,//市审核
                        dlrflag:item.dlrflag,//待录入
                        dsbflag:item.dsbflag,//待上报
                        ythflag:item.ythflag,//已退回
                        active2:this.active2,
                        levelNum:item.levelNum,
                        priceDate:item.priceDate,
                        lateReportTime:item.lateReportTime,
                        startTime: this.startTime,
                        endTime: this.endTime
                    }
                });
            }
        },
        navSwitch() {
            this.isBarNav = !this.isBarNav
        },
        
        //置顶图标
        backTop() {
            const that = this
            const timer = setInterval(() => {
                const ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                    clearInterval(timer)
                }
            }, 16)
        },
        // 为了计算距离顶部的高度，当高度大于130显示回顶部图标，小于130则隐藏
        scrollToTop() {
            const that = this
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            that.scrollTop = scrollTop
            that.btnFlag = that.scrollTop > 130;
            // that.isBarNav = that.scrollTop > 10;
        },
        onRefresh() {
            setTimeout(() => {
                this.isLoading = false;
                this.init();
            }, 300);
        },
        onClickLeft() {
            this.$router.push({
                path: '/',
            });
        },
        search() {
            this.getAllCollectionTask();
        },
        onLoad() { //tabcard加载函数
            // 异步更新数据
            // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            setTimeout(() => {
                // 加载状态结束
                this.loading1 = false;
                this.finished = true;
            }, 1000);
        },
        //监测登陆状态 houcc 2021.07.24
        checkLogin() {
            checkLogin({}).then(res => {
                if (!res.success) {
                    // nativeJSBridge.logout();
                    this.$router.push({ path: '/loginOld'});
                }
                this.loginStatus = res.success;
            })
        },
        fuzzyQuery(keyWord) {//搜索筛选方法
            // if(keyWord.length==0) {
            //     return
            // }
            const arr = [];
            for(let i = 0;i < this.tableList.length;i++) {
                if(this.tableList[i].taskName.indexOf(keyWord) >= 0) {
                    arr.push(this.tableList[i]);
                }
            }
            this.inputTable = arr;
        },
        dropClick(code, name) {
            //选择下拉列表点击事件
            this.dropdownInput = name;
            this.showDrop = !this.showDrop;
            this.taskCode=code;//任务code
            if(this.active2===0){
                this.getCaseCount();
            }else if(this.active2===1){
                this.getAllCollectionTask();
            }
        },
        hideTabs() {//隐藏展示滚动tabs
            this.fuzzyQuery(this.dropdownInput);
            this.showDrop = true;
        },
        showTabs() {//展示滚动tabs
            this.showDrop = false;
        }
    },
    watch: {
        $route() {
            this.type = this.$route.query.type;
        },
    }
}